import $, { AxiosPromise } from 'axios';
import { GetURI } from './utilities';
import { LogIt } from '@/plugins/webApi';

const BASEURL = `${GetURI()}/api/users`;

interface UserConstructor {
    isDelete?: boolean;
    name: string;
}

export class ApiUsers {
    public method: string;
    public userName: string;
    constructor(data: UserConstructor) {
        if (data.isDelete !== null || data.isDelete !== undefined) {
            this.method = data.isDelete ? 'delete' : 'post';
        } else {
            this.method = 'get';
        }
        this.userName = data.name;
    }
    public send(): AxiosPromise {
        if (this.method === 'delete') {
            LogIt(`Removing User ${this.userName}`, false);
            return $({ url: `${BASEURL}/${this.userName}`, method: 'DELETE'});
        } else if (this.method === 'post') {
            LogIt(`Create User ${this.userName}`, false);
            return $({ url: `${BASEURL}/`, method: 'POST', data: { name: this.userName }});
        } else {
            LogIt(`Get User ${this.userName}`, false);
            return $({ url: `${BASEURL}/${this.userName}`, method: 'GET'});
        }
    }
}
